import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_DIGITAL_TWIN_INLCM_END = {
  title: "Find out more about Network \nLifecycle Manager from our staff.",
  bgImage: "ENG/INLCM/INLCM_dark_bg_1.png",
  optionsButtons: [
    {
      label: "OVERVIEW",
      onClick: () => setCurrentPage("ENG_301"),
      type: "transparent",
      startIcon: "arrow-left",
    },
    {
      label: "RESTART DEMO",
      onClick: () => setCurrentPage("ENG_310"),
      endIcon: "arrow-right",
    },
    {
      label: "Select another demo",
      onClick: () => setCurrentPage("ENG_306"),
      endIcon: "arrow-right",
    },
  ],
};
